import { Routes, Route } from "react-router-dom";
import SubscribeEn from "../pages/SubscribeEn";
import SubscribeFr from "../pages/SubscribeFr";
import SuccessEn from "../pages/SuccessEn";
import SuccessFr from "../pages/SuccessFr";
import UnsubscribeEn from "../pages/UnsubscribeEn";
import UnsubscribeFr from "../pages/UnsubscribeFr";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/en/subscribe" element={<SubscribeEn />} />
      <Route path="/fr/abonnement" element={<SubscribeFr />} />
      <Route path="/en/success" element={<SuccessEn />} />
      <Route path="/fr/reussi" element={<SuccessFr />} />
      <Route path="/en/unsubscribe" element={<UnsubscribeEn />} />
      <Route path="/fr/desabonnement" element={<UnsubscribeFr />} />
    </Routes>
  );
};

export default AppRoutes;
